import { List } from 'modules/domains/list';
import { Campaign } from 'modules/campaignIndex/types/Campaign';
import { IndexPageTemplate } from 'modules/templateIndex';
import { WorkflowType } from 'modules/workflowIndex/types';
import { ResourceType } from 'modules/missionControl/lib/types';

export enum ActionType {
  Created = 'created',
  Updated = 'updated',
  // Not currently supported for Homepage alpha
  // PageView = 'Viewed',
}

export type ActivityItem = {
  actionType: ActionType;
  id: number;
  projectId: number;
  resourceId: number;
  resourceType: ResourceType;
  trackedAt: string;
  userId: number;
  writtenAt: string;
};

export type ActivityItems = ActivityItem[];

export type JourneyResourceData = {
  id: number;
  name: string;
  workflowType: WorkflowType;
  isArchived: boolean;
};

export type ResourceData = Campaign | List | IndexPageTemplate | JourneyResourceData;

export type LaunchpadState = {
  isLoadingState: boolean;
  isErrorState: boolean;
  isEmptyState: boolean;
  isDataState: boolean;
  isZeroState: boolean;
};
